const footerLists = [
    {
        key: 1,
        title: "Tables & Desk",
        items: [
            {
                key: "1a",
                name: "Living Room",
            },
            {
                key: "1b",
                name: "Bathroom",
            },
            {
                key: "1c",
                name: "Bedroom",
            },
            {
                key: "1d",
                name: "Dining",
            },
            {
                key: "1e",
                name: "Kitchen",
            },
            {
                key: "1f",
                name: "Laundry",
            },
            {
                key: "1g",
                name: "Balcony",
            },
            {
                key: "1h",
                name: "Home Office",
            },
        ]
    },
    {
        key: 2,
        title: "Shop at Mao",
        items: [
            {
                key: "2a",
                name: "About the Store",
            },
            {
                key: "2b",
                name: "How to Shop",
            },
            {
                key: "2c",
                name: "Mao App",
            },
        ]
    },
    {
        key: 3,
        title: "Other Services",
        items: [
            {
                key: "3a",
                name: "Architectural Design",
            },
            {
                key: "3b",
                name: "3D Modelling Services",
            },
        ]
    },
    {
        key: 4,
        title: "Customer Services",
        items: [
            {
                key: "4a",
                name: "Return and Exchange",
            },
            {
                key: "4b",
                name: "Order Cancellation",
            },
            {
                key: "4c",
                name: "Product Warranty",
            },
            {
                key: "4d",
                name: "FAQs",
            },
            {
                key: "4e",
                name: "Contact Us",
            },
        ]
    },
]

export default footerLists;